































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import ArrayUtil from '@/models/common/arrayutil';
import Enumerable from 'linq';
import StatusStore from '../../models/status/statusstore';

class SoldierTypePickerItem {
  constructor(public type: def.SoldierType,
              public isLackOfResources: boolean,
              public resource: number) {}
}

@Component({
  components: {
    CharacterIcon,
  },
})
export default class SoldierTypePicker extends Vue {
  public types: SoldierTypePickerItem[] = [];
  @Prop() public soldierTypes!: def.SoldierType[];
  @Prop({
    default: () => new def.SoldierType(-1),
  }) public value!: def.SoldierType;
  @Prop({
    default: () => [],
  }) public skills!: api.CharacterSkill[];
  @Prop({
    default: () => [],
  }) public items!: api.CharacterItem[];
  @Prop({
    default: 0,
  }) public mode!: number;

  @Watch('soldierTypes')
  @Watch('items')
  public onTypesChanged() {
    this.types = this.soldierTypes.filter((st) => {
      if (st.warMode !== this.mode) {
        return false;
      }
      if (st.requestedSkillType && !st.isNeedResource) {
        return this.skills.some((s) => !Array.isArray(st.requestedSkillType) ?
                                              s.type === st.requestedSkillType :
                                              st.requestedSkillType.some((k) => k === s.type));
      }
      return true;
    }).map((st) => {
      let isLackOfResources = false;
      let resourceNumber = 0;
      if (st.isNeedResource) {
        const resources = this.items.filter((i) => i.type === st.requestedItemType);
        if (resources.length > 0) {
          isLackOfResources = false;
          resourceNumber = Enumerable.from(resources).sum((r) => r.resource);
        } else {
          isLackOfResources = true;
        }
      }
      return new SoldierTypePickerItem(st, isLackOfResources, resourceNumber);
    });
  }

  public getSoldierMoney(type: def.SoldierType): number {
    if (this.skills.some((s) => s.type === 3)) {
      return Math.floor(type.money * 0.9);
    }
    return type.money;
  }
}
